export const EMAIL_ID = "email";
